import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { EventOutcomePriority } from '../event-outcome/event-outcome.types';
import { EVENT_OUTCOME_PRIORITY_ORDER } from '../event-outcome/event-outcome.types';
import { EventqResolveQueueRow } from './resolve-queue-row';

/** Colored resolve-queue row placeholders shown while a queue bucket is loading. */
@Component({
  selector: 'eventq-resolve-queue-skeleton-list',
  imports: [EventqResolveQueueRow],
  templateUrl: './resolve-queue-skeleton-list.html',
  styleUrl: './resolve-queue-skeleton-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqResolveQueueSkeletonList {
  readonly count = input(5);
  readonly priorities = input<readonly EventOutcomePriority[]>(EVENT_OUTCOME_PRIORITY_ORDER);

  skeletonPriorities(): EventOutcomePriority[] {
    const tones = this.priorities();
    const n = Math.max(0, this.count());
    return Array.from({ length: n }, (_, index) => tones[index % tones.length]!);
  }
}
